module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowTriangleDown.f1519fe8.svg";